import angular from 'angular';

import tszCompanySettings from './tsz-company-settings';

const tszCompanySettingsModule = angular.module('tsz.components.tszCompanySettings', [])
  .component('tszCompanySettings', tszCompanySettings);

export default tszCompanySettingsModule;



// WEBPACK FOOTER //
// ./src/components/tsz-company-settings/tsz-company-settings.module.js